import { IconCredits } from '@bitrise/bitkit-v2';

import { InsightsDetails } from '@/pages/BuildDetailsPage/hooks/useInsightsDetails';

import RunnableMeta from './RunnableMeta';

const CreditsMeta = ({ data, insightsDetails }: { data?: string; insightsDetails?: InsightsDetails }) => {
  return (
    <RunnableMeta
      icon={IconCredits}
      data={data}
      defaultTooltipLabel="Credit cost"
      status={insightsDetails?.credits?.increasedBy ? 'increasing' : undefined}
      definitionButton={{ href: insightsDetails?.credits?.url, label: 'View trends' }}
      definitionText={
        insightsDetails?.credits?.increasedBy
          ? `Credit cost increased by ${insightsDetails.credits.increasedBy}%.`
          : undefined
      }
    />
  );
};

export default CreditsMeta;
